import { Button, Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { FC, useRef, useState } from 'react'
import { useForm } from 'react-final-form'
import Dialog from '../../../control/dialog/dialog'
import useLoading from '../../../control/loading/useLoading'
import useTranslate from '../../../i18n/useTranslate'
import useCommittees from '../shareLogic/useCommittees'
import { useCommitteeStyles } from './committeeStyles'

const ProjectInfo: FC<{ inProgress: number; success: number; committeeID: number; isInProgress: boolean }> = ({
    inProgress,
    success,
    committeeID,
    isInProgress,
}) => {
    const classes = useCommitteeStyles()
    const projectInfoRef = useRef<Record<string, Function>>()
    const translate = useTranslate()
    const committeeHook = useCommittees()
    const loadingHook = useLoading()
    const [projectInfoList, setProjectInfoList] = useState<
        {
            projectNumber: string
            nameTH: string
            nameEN: string
        }[]
    >([])
    const form = useForm()

    const bindProjectInfoRef = (func: Record<string, Function>) => {
        projectInfoRef.current = { ...func }
    }

    const openProjectInfo = async () => {
        const formValues = form.getState().values
        loadingHook.loadingOpen()
        const projectInfo = await committeeHook.getProjectInfo(
            committeeID,
            isInProgress,
            formValues.currentStartDate,
            formValues.currentEndDate,
        )
        if (projectInfo.result) {
            setProjectInfoList(projectInfo.result)
        }
        loadingHook.loadingClose()
        projectInfoRef.current?.openDialog()
    }

    const closeProjectInfo = () => {
        projectInfoRef.current?.closeDialog()
    }

    return (
        <>
            <Typography variant="body2" className={classes.linkLabel} onClick={() => openProjectInfo()}>
                {translate.get('LABEL.COMMITTEE_PROJECT', [isInProgress ? `${inProgress}` : `${success}`])}
            </Typography>
            <Dialog
                onRef={bindProjectInfoRef}
                type=""
                title={translate.get('LABEL.PROJECT_INFO')}
                content={
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Grid container>
                                <Grid item xs={3}>
                                    <Typography variant="body2" className={classes.header}>
                                        {translate.get('LABEL.PROJECT_NUMBER')}
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography variant="body2" className={classes.header}>
                                        {translate.get('LABEL.PROJECT_NAME')}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {projectInfoList.length > 0 ? (
                            projectInfoList?.map((data, index) => (
                                <Grid item xs={12} key={index}>
                                    <Grid container>
                                        <Grid item xs={3}>
                                            <Typography variant="body2">{data.projectNumber}</Typography>
                                        </Grid>
                                        <Grid item xs={9}>
                                            <Typography variant="body2">
                                                {translate.languageStore.currentLanguage === translate.languageKey.th
                                                    ? data.nameTH
                                                    : data.nameEN}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body2">{translate.get('LABEL.NO_DATA_FOUND')}</Typography>
                            </Grid>
                        )}
                        <Grid item xs={12} style={{ position: 'sticky', bottom: '-8px', backgroundColor: '#fff' }}>
                            <Grid container justifyContent="center">
                                <Grid item>
                                    <Button color="primary" variant="outlined" onClick={closeProjectInfo}>
                                        {translate.get('BUTTON.CLOSE_MODAL')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            />
        </>
    )
}

export default ProjectInfo
